export default {
  text: '{{threshold}} maandelijkse omzet: {{amount}}',
  label: '{{threshold}} maandelijkse omzet:',
  no_discount: 'geen korting',
  discount_badge: '-{{percentage}}%',
};
